<template>
	<div class="chat-coustom-box">
		<div class="chat-coustom-title">
			<div>我的账号（{{customList.length}}）</div>
			<div class="chat-coustom-search">
				<input type="text" v-model="keyword" placeholder="输入昵称/机型号"/>
				<span class="chat-coustom-search-icon"></span>
				<span class="chat-coustom-search-refresh" @click="refresh"></span>
			</div>
		</div>
		<div class="chat-coustom-list">
			<div class="chat-coustom-list-wrap">
				<div class="chat-coustom-items">
					<div class="chat-coustom-item" v-for="custom in customList">
						<div class="chat-coustom-header">
							<div class="chat-coustom-h-info">
								<p class="chat-coustom-h-name">{{custom.wx_name}}</p>
								<p>微信号：{{custom.open_id}}</p>
							</div>
							<div class="chat-coustom-h-avatar">
								<img :src="custom.wx_photo | connectHost" alt="">
							</div>
						</div>
						<div class="chat-coustom-extra">
							<div class="chat-coustom-e-item">
								<div class="chat-coustom-ei-title">好友数：</div>
								<div class="chat-coustom-ei-text">{{custom.fansCount}}个</div>
							</div>
							<div class="chat-coustom-e-item">
								<div class="chat-coustom-ei-title">群&nbsp;&nbsp;&nbsp;&nbsp;数：</div>
								<div class="chat-coustom-ei-text">{{custom.clusterCount}}个</div>
							</div>
							<div class="chat-coustom-e-item">
								<div class="chat-coustom-ei-title">消息数：</div>
								<div class="chat-coustom-ei-text">{{custom.msgCount}}个</div>
							</div>
							<div class="chat-coustom-e-item">
								<div class="chat-coustom-ei-title">机型号：</div>
								<div class="chat-coustom-ei-text">{{custom.identity}}</div>
							</div>
							<div class="chat-coustom-e-item">
								<div class="chat-coustom-ei-title">状&nbsp;&nbsp;&nbsp;&nbsp;态：</div>
								<div class="chat-coustom-ei-text">
									<span class="chat-coustom-ei-online" :class="{'chat-coustom-ei-outline' : custom.is_online === 0}">{{ custom.is_online == 1 ? '在线' : '离线'}}</span>
									<!-- <span class="chat-coustom-ei-time">[今天08:45]</span> -->
								</div>
							</div>
						</div>
						<div class="chat-coustom-tools">
							<div class="chat-coustom-t-item" style="background-color: #009688;" @click="syncClusterList(custom)">
								<span class="chat-coustom-ti-icon chat-coustom-ti-gc"></span>
								<span class="chat-coustom-ti-text">群同步</span>
							</div>
							<div class="chat-coustom-t-item" style="background-color: #e6c341;" @click="syncCustomFans(custom)">
								<span class="chat-coustom-ti-icon chat-coustom-ti-gf"></span>
								<span class="chat-coustom-ti-text">粉丝同步</span>
							</div>
							<div class="chat-coustom-t-item" style="background-color: #13b9ff;" @click="reStart(custom)">
								<span class="chat-coustom-ti-icon chat-coustom-ti-reload"></span>
								<span class="chat-coustom-ti-text">重启</span>
							</div>
							<div class="chat-coustom-t-item" style="background-color: #ff5f2a;" @click="clearRedDot(custom)">
								<span class="chat-coustom-ti-icon chat-coustom-ti-s"></span>
								<span class="chat-coustom-ti-text">清点</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {getCustomList,getCustomFansCount,getCustomClusterCount,getCustomMsgCount} from '../../../network/local/custom.js'
	import {pushC_SyncCluster,pushSysFans,pushRestartPhone,pushClearRedDot} from '../../../socket/socketEventSender.js'
	import {canSync} from '../../../network/web/custom.js'
	
	export default {
		name: "ChatCustomHome",
		data(){
			return {
				orgCustomList:[],
				customList:[],
				keyword: ''
			}
		},
		methods:{
			// 渲染客服列表
			drawList(){
				// 拼接客服列表信息
				getCustomList(data=>{
					let customIds = []
					let openIds = []
					this.keyword = ''
					for (let i = 0; i < data.length; i++) {
						customIds.push(data[i].id)
						openIds.push(data[i].open_id)
					}
					getCustomFansCount(customIds,fansData=>{
						getCustomClusterCount(openIds,clusterData=>{
							getCustomMsgCount(customIds,msgData=>{
								let custom = []
								let customOutLine = []
								for (let i = 0; i < data.length; i++) {
									// 拼接粉丝总数
									let fansCount = 0
									for (let j = 0; j < fansData.length; j++) {
										if(fansData[j].custom_id == data[i].id){
											fansCount = fansData[j].fans_total
											break
										}
									}
									// 拼接群总数
									let clusterCount = 0
									for (let j = 0; j < clusterData.length; j++) {
										if(clusterData[j].open_id == data[i].open_id){
											clusterCount = clusterData[j].cluster_total
											break
										}
									}
									// 拼接消息总数
									let msgCount = 0
									for (let j = 0; j < msgData.length; j++) {
										if(msgData[j].custom_id == data[i].id){
											msgCount = msgData[j].msg_total
											break
										}
									}
									data[i].fansCount = fansCount
									data[i].clusterCount = clusterCount
									data[i].msgCount = msgCount
									if(data[i].is_online == 1){
										custom.push(data[i])
									}else{
										customOutLine.push(data[i])
									}
								}
								let customAll = custom.concat(customOutLine)
								this.orgCustomList = JSON.parse(JSON.stringify(customAll))
								this.customList = customAll
							})
						})
					})
				})
			},
			
			// 同步客服群列表
			syncClusterList(custom){
				CHAT_LAYER.msg('群同步指令推送成功！',{icon:7})
				pushC_SyncCluster(custom.open_id,custom.phone_id)
			},
			
			// 粉丝同步
			syncCustomFans(custom){
				canSync(custom.phone_id,data=>{
					if(data.code == 1){
						CHAT_LAYER.msg('粉丝同步指令推送成功！',{icon:7})
						pushSysFans(custom.phone_id)
					}else{
						CHAT_LAYER.msg(data['msg'],{icon:2})
					}
				})
			},
			
			// 重启手机
			reStart(custom){
				CHAT_LAYER.confirm('确认要重启"<span style="color: red">'+ custom.wx_name + '-' + custom.identity +'</span>"这个手机吗？',{
					btn: ['重启', '取消']
				},
				function(index, layero){
				  CHAT_LAYER.msg('粉丝同步指令推送成功！',{icon:7})
				  pushRestartPhone(custom.phone_id)
				}, 
				function(index){
				 
				})	
			},
			
			// 清除未读消息
			clearRedDot(custom){
				CHAT_LAYER.confirm('确认清除"<span style="color: red">'+ custom.wx_name + '-' + custom.identity +'</span>"的未读消息吗？',{
					btn: ['确定', '取消']
				},
				function(index, layero){
				  CHAT_LAYER.msg('清除未读消息指令推送成功！',{icon:7})
				  pushClearRedDot(custom.phone_id)
				}, 
				function(index){
				 
				})	
			},
			
			
			// 刷新
			refresh(){
				CHAT_LAYER.msg('刷新成功！')
				this.drawList()
			}
		},
		mounted() {
			this.drawList()
		},
		
		watch:{
			keyword(nVal){
				let customList = []
				for (var i = 0; i < this.orgCustomList.length; i++) {
					if(nVal === ''){
						customList.push(this.orgCustomList[i])
					}else{
						if(this.orgCustomList[i].wx_name.indexOf(nVal) !== -1 || this.orgCustomList[i].identity.indexOf(nVal) !== -1){
							customList.push(this.orgCustomList[i])
						}
					}
				}
				this.customList = customList
			}
		}
	}
</script>

<style>
	.chat-coustom-box{
		position: relative;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	.chat-coustom-box .chat-coustom-title{
		padding: 0 25px;
		height: 60px;
		line-height: 60px;
		border-bottom: 1px solid #d9d9d9;
		font-size: 16px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.chat-coustom-title .chat-coustom-search{
		width: 230px;
		height: 26px;
		position: relative;
	}
	.chat-coustom-search input{
		background-color: #E6E6E6;
		width: 200px;
		height: 26px;
		display: block;
		padding: 0 10px 0 26px;
		box-sizing: border-box;
		color: #777777;
		font-size: 12px;
		border-radius: 4px;
	}
	.chat-coustom-search .chat-coustom-search-icon{
		display: block;
		position: absolute;
		width: 26px;
		height: 26px;
		top: 0;
		left: 0;
		background-image: url(../../../assets/img/c-all-search.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 16px auto;
	}
	.chat-coustom-search .chat-coustom-search-refresh{
		display: block;
		position: absolute;
		width: 26px;
		height: 26px;
		top: 0;
		right: 0;
		background-color: #E6E6E6;
		background-image: url(../../../assets/img/comp-m-reload.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 16px auto;
		border-radius: 4px;
		cursor: pointer;
	}
	.chat-coustom-box .chat-coustom-list{
		position: absolute;
		top: 80px;
		left: 20px;
		right: 20px;
		bottom: 20px;
		overflow: hidden;
	}
	.chat-coustom-list .chat-coustom-list-wrap{
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.chat-coustom-list-wrap .chat-coustom-items{
		width: 100%;
		height: auto;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
	}
	.chat-coustom-items .chat-coustom-item{
		width: 360px;
		border-radius: 6px;
		background-color: #f4f4f4;
		padding: 15px;
		color: #888888;
		margin: 10px;
		box-shadow: 0 0 6px 0 #b3b3b3;
	}
	.chat-coustom-item .chat-coustom-header{
		height: 50px;
		width: 100%;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
	}
	.chat-coustom-header .chat-coustom-h-avatar{
		height: 50px;
		width: 50px;
		overflow: hidden;
		margin-left: 10px;
	}
	.chat-coustom-h-avatar img{
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}
	.chat-coustom-header .chat-coustom-h-info{
		flex-grow: 1;
		width: 0;
		height: 50px;
		overflow: hidden;
	}
	.chat-coustom-h-info p{
		height: 25px;
		line-height: 25px;
	}
	.chat-coustom-h-info .chat-coustom-h-name{
		font-weight: 600;
		color: #333333;
	}
	.chat-coustom-item .chat-coustom-extra{
		margin-top: 10px;
	}
	.chat-coustom-extra .chat-coustom-e-item{
		width: 100%;
		height: 30px;
		line-height: 30px;
		display: flex;
		justify-content: flex-start;
	}
	.chat-coustom-e-item .chat-coustom-ei-title{
		height: 30px;
		width: 60px;
		overflow: hidden;
	}
	.chat-coustom-e-item .chat-coustom-ei-text{
		color: #333333;
	}
	.chat-coustom-ei-text span{
		height: 14px;
		line-height: 14px;
		padding: 2px 10px;
		display: inline-block;
		vertical-align: middle;
	}
	.chat-coustom-ei-text .chat-coustom-ei-online{
		background-color: #009E94;
		margin-right: 4px;
		color: #FFFFFF;
		border-radius: 2px;
	}
	.chat-coustom-ei-text .chat-coustom-ei-outline{
		background-color: rgb(255, 95, 42) !important;
	}
	.chat-coustom-ei-text .chat-coustom-ei-time{
		color: #999999;
		padding: 0 0 !important;
		font-size: 12px;
	}
	.chat-coustom-item .chat-coustom-tools{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		margin-top: 10px;
		user-select: none;
	}
	.chat-coustom-tools .chat-coustom-t-item{
		height: 20px;
		line-height: 20px;
		margin: 0 5px;
		padding: 2px 5px;
		cursor: pointer;
		background-color: #009688;
		color: #FFFFFF;
		font-size: 12px;
		border-radius: 2px;
	}
	.chat-coustom-t-item span{
		display: inline-block;
		vertical-align: middle;
	}
	.chat-coustom-t-item .chat-coustom-ti-icon{
		width: 20px;
		height: 20px;
		background-position: center;
		background-repeat: no-repeat;
		background-size: 16px auto;
	}
	.chat-coustom-ti-s{
		background-image: url(../../../assets/img/stop-e6-32.png);
		background-size: 14px auto !important;
	}
	.chat-coustom-ti-gc{
		background-image: url(../../../assets/img/cluster-e6-32.png);
		background-size: 15px auto !important;
	}
	.chat-coustom-ti-gf{
		background-image: url(../../../assets/img/fans-e6-32.png);
		background-size: 14px auto !important;
	}
	.chat-coustom-ti-uc{
		background-image: url(../../../assets/img/update-e6-32.png);
	}
	.chat-coustom-ti-reload{
		background-image: url(../../../assets/img/mobile-reload.png);
	}
</style>
